/**
 * BackButton Component
 * Reusable back navigation button
 * Matches AuthHeader and HeroBanner styling
 */

import { ChevronLeft } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { cn } from "@/lib"

export interface BackButtonProps {
  onClick?: () => void
  label?: string // Default: "Back"
  className?: string
  ariaLabel?: string
}

export function BackButton({
  onClick,
  label = "Back",
  className = "",
  ariaLabel = "Go back",
}: BackButtonProps) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      navigate(-1)
    }
  }

  return (
    <Button
      variant="outline"
      onClick={handleClick}
      aria-label={ariaLabel}
      className={cn("flex items-center gap-2 px-3 py-2 rounded-lg", className)}
    >
      <ChevronLeft className="w-4 h-4" aria-hidden="true" />
      <span className="text-sm font-medium">{label}</span>
    </Button>
  )
}
